import { createGlobalStyle } from 'styled-components'

import { DIALOG_CLASS_NAMES } from '@constants'

export const GlobalStyle = createGlobalStyle`
  .${DIALOG_CLASS_NAMES.body},
  .${DIALOG_CLASS_NAMES.html} {
    overflow: hidden;
  }

  html {
    scroll-padding-top: calc(${({ theme }) => theme.appBarHeight}px + ${({ theme }) => theme.newVersionBarOffset});
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  strong, b {
    font-weight: 700;
  }

  body {
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
    font-size: 1rem;
    font-family: Open Sans;
    font-weight: 400;
    line-height: 1.43;
    background-color: ${({ theme }) => theme.colors.common.inputBackground};
  }

  @media print {
    body {
      background-color: ${({ theme }) => theme.colors.gray[0]};
    }
  }
    
  body::backdrop {
    background-color: ${({ theme }) => theme.colors.common.inputBackground};
  }

  body, input, textarea, keygen, select, button {
    font-family: "Open Sans", "Segoe UI", Tahoma, sans-serif;
  }

  button {
    margin: 0;
  }
`
